import { sheepPathData, sheepPathSize } from '../sheepShape'

const styleId = 'icf-easter-egg-sheep-style'

// Same sheep as in blocks/yellowtree/not-found/template.php and in the sheep
// run mini-game - it faces right, so it runs left to right without flipping.
const sheepSvg = `<svg width="${sheepPathSize.width}" height="${sheepPathSize.height}" viewBox="0 0 ${sheepPathSize.width} ${sheepPathSize.height}" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="${sheepPathData}" fill="currentColor"/>
</svg>`

// Styles are injected from JS on purpose: PurgeCSS only scans
// php/html/jsx/tsx sources, so classes referenced solely in this .ts file
// would be purged from the compiled stylesheets.
const css = `
.icf-easter-egg-sheep {
  position: fixed;
  bottom: 2vh;
  left: 0;
  z-index: 9999;
  pointer-events: none;
  color: var(--bs-body-color, #3f3f3f);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  animation: icf-easter-egg-sheep-run var(--icf-egg-sheep-duration) linear forwards;
}

.icf-easter-egg-sheep > svg {
  display: block;
  animation: icf-easter-egg-sheep-hop 0.4s ease-in-out infinite alternate;
}

@keyframes icf-easter-egg-sheep-run {
  from { transform: translateX(-100px); }
  to { transform: translateX(calc(100vw + 100px)); }
}

@keyframes icf-easter-egg-sheep-hop {
  from { transform: translateY(0); }
  to { transform: translateY(-14px); }
}
`

function injectStyles() {
  if (document.getElementById(styleId)) return
  const style = document.createElement('style')
  style.id = styleId
  style.textContent = css
  document.head.appendChild(style)
}

export function playSheep(options: { durationMs?: number }) {
  const { durationMs = 5000 } = options
  // a sheep hopping across the screen is real motion - skip it entirely
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  injectStyles()

  const sheep = document.createElement('div')
  sheep.className = 'icf-easter-egg-sheep'
  sheep.setAttribute('aria-hidden', 'true')
  sheep.style.setProperty('--icf-egg-sheep-duration', `${durationMs}ms`)
  sheep.innerHTML = sheepSvg
  // the inner hop animation never ends - only the run on the wrapper does
  sheep.addEventListener('animationend', (event) => {
    if (event.target === sheep) sheep.remove()
  })
  setTimeout(() => sheep.remove(), durationMs + 1000)

  document.body.appendChild(sheep)
}
